import styled from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

export const Header = styled.header`
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${({ $color }) => $color};

    padding-top: 150px;

    ${mobile(`
        padding-top: 100px;
        padding-bottom: 30px;
    `)}
`

export const Content = styled.div`
    max-width: 1140px;
    padding: 0 15px;

    display: flex;
    justify-content: center;
    align-items: flex-start;

    ${mobile(`
        flex-direction: column;
    `)}
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 520px;

    > * + * {
        margin-top: 30px;
    }

    ${mobile(`
        padding: 20px 0px;
    `)}
`

export const Background = styled.div`
    display: block;

    position: relative;
    top: -1px;
    left: 0;
    z-index: -10;

    width: 100%;
    height: 14vw;

    background-image: url(${({ $bgImage }) => $bgImage});
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 150%;
`

export const Title = styled.h1`
    font-size: 68px;
    font-weight: 700;
    line-height: 76px;

    background: ${({ $gradient }) => $gradient};
    -webkit-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;

    ${mobile(`
        font-size: 52px;
        line-height: 1;
    `)}
`

export const Name = styled.h2`
    font-size: 40px;
    font-weight: 800;
    line-height: 44px;

    color: ${colors.white};

    ${mobile(`
        font-size: 27px;
        line-height: 0.5;
    `)}
`
export const Text = styled.h3`
    font-size: 32px;
    font-weight: 400;
    line-height: 40.64px;

    color: ${colors.white};

    ${mobile(`
        font-size: 24px;
        line-height: 1.3;
    `)}
`
